import {StyleSheet} from 'react-native';
export const styles = StyleSheet.create({
  subContainer: {marginVertical: 15},
  imageBox: {
    marginRight: 20,
    position: 'relative',
  },
  textStyle: {textAlign: 'left'},
  image: {
    height: 75,
    width: 75,
  },
  subImage: {
    position: 'absolute',
    bottom: 0,
    left: 0,
    height: 24,
    width: 24,
  },
  headerText: {marginBottom: 10},
  priceText: {marginTop: 5},
  cellContainer: {
    flex: 1,
    alignItems: 'flex-start',
    alignSelf: 'stretch',
    borderWidth: 1,
    borderRadius: 10,
    padding: 5,
    paddingLeft: 10,
  },
  iconContainer: {marginHorizontal: 10},
});
